// Version information - injected at build time by Vite

// Raw build-time values
export const BUILD_TIME = __BUILD_TIME__
export const GIT_HASH = __GIT_HASH__

/**
 * Format ISO timestamp to human-readable version string
 * Example: "2026.02.16-14:23"
 */
function formatBuildTime(isoString: string): string {
  try {
    const date = new Date(isoString)
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    return `${year}.${month}.${day}-${hours}:${minutes}`
  } catch {
    return 'unknown'
  }
}

// Human-readable version string
export const VERSION = formatBuildTime(BUILD_TIME)
